/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {EntryMetadata} from "./EntryMetadata";
/**
 * Created by andrea on 2017-06-24.
 */

export class EntryType extends EntryMetadata {

  constructor(id: string, name: string, description: string, minDancers: number, maxDancers: number) {
    if (!description) {
      if (minDancers < maxDancers) {
        description = `${minDancers} - ${maxDancers} dancers`;
      } else if (maxDancers < minDancers) {
        description = `${minDancers}+ dancers`;
      } else {
        description = `${minDancers} ${minDancers > 1 ? 'dancers' : 'dancer'}`;
      }
    }

    super(id, name, description);
  }

  static listFromSnapshot(key: string, val: [{name, description, minDancers, maxDancers}]) {
    let items: Array<EntryType> = [];

    for (let id of Object.keys(val)) {
      items.push(new EntryType(id, val[id].name, val[id].description, val[id].minDancers, val[id].maxDancers));
    }

    return items;
  }

}



// WEBPACK FOOTER //
// ./src/models/schedule/metadata/EntryType.ts